import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export type ReviewMethod = 'PATCH' | 'DELETE';

export const reviewPriceSchemeImport = async (eventId: string, method: ReviewMethod): Promise<void> => {
  try {
    const res = await fetch(`${API_URL}/pricing/schemes/import/${eventId}`, {
      method,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!res.ok) {
      const result = await res.json();
      throw new Error(result.message);
    }
  } catch (e) {
    throw new Error(e instanceof Error ? e.message : 'Failed to update price scheme import');
  }
};
